import { FC, useCallback, useEffect, useRef, useState } from 'react';
import {
  Switch,
  Route,
  useRouteMatch,
  useHistory
} from 'react-router-dom';
import { useWxWork } from '@cloud/wxwork-workbench';
import PageLayout from '@/layouts/page';
import List, { ActionType as ListActionType } from '@/components/List';
import { go, goBack } from '@/utils';
import DetailPage from './detail';
import { querySOPCountInfo, querySOPList, SOPCountInfoResult } from './service';
import styles from './index.less';
import { SOPType, SOPStatus, sopTypeList, sopStatusList } from './constants';
import classNames from 'classnames';
import Button from '@/components/Button';


const AddFriendTasksPage: FC<{}> = () => {
  const history = useHistory();
  let { path, url } = useRouteMatch();
  const listActionRef = useRef<ListActionType>();
  const signature = useWxWork();
  const [type, setType] = useState<SOPType>(sopTypeList[0].key);
  const [status, setStatus] = useState<SOPStatus>(sopStatusList[0].key);
  const [countInfo, setCountInfo] = useState<SOPCountInfoResult>();
  const [refresh, setRefresh] = useState<boolean>(false);


  useEffect(() => {
    if (refresh) {
      setTimeout(() => setRefresh(false));
    }
    if (signature.corpId && signature.userId) {
      querySOPCountInfo(signature).then(setCountInfo);
    }
  }, [signature, refresh]);

  useEffect(() => {
    if (listActionRef.current) {
      listActionRef.current.refresh();
    }
  }, [type, status, history.location.pathname]);

  const handleTabChange = (k: SOPStatus) => {
    setStatus(k);
  }

  const handleCheckDetail = (id: UKey) => {
    go(history, `${url}/${id}/${type}`);
  }

  const fetchList = useCallback(async params => {
    setRefresh(true);
    const res = await querySOPList({ type, status, ...params }, signature);
    return { data: res.data, pagination: res.pagination };
  }, [type, status, signature]);

  const handleTypeChange = (key: SOPType) => {
    setType(key);
    setStatus(sopStatusList[0].key);
  }

  const renderTitle = () =>
    <div className={styles.title}>
      {sopTypeList.map(
        ({ key, title }) =>
          <span key={key}
            className={classNames(
              styles.tabItem,
              { [styles.active]: key === type }
            )}
            onClick={key === type ? undefined : () => handleTypeChange(key)}
          >{title}SOP任务</span>
      )}
      <span className={styles.divided}/>
    </div>

  return (
    <Switch>
      <Route exact path={path}>
        <PageLayout
          title={renderTitle()}
          tabs={sopStatusList.map(({ key, title, dataKey }) => ({
            key, title,
            count: countInfo?.[`${sopTypeList.find(({ key: k }) => k === type).dataKey}Data`]?.[`${dataKey}Count`]
          }))}
          activeKey={status}
          onTabChange={handleTabChange}
        >
          <div className={styles.main}>
            <List
              actionRef={r => listActionRef.current = r}
              request={fetchList}
              loadDataLength={99999}
              scrollThreshold='0px'
              rowKey='id'
              renderItem={(({ id, sopName, scene, executeTime, totalAmount, sendAmount }) => (
                <div className={styles.preview}>
                  <h4 className={styles.name}>{sopName}</h4>
                  <div className={styles.description}>
                    {
                      type === SOPType.CUSTOMER_SOP &&
                      <div className={styles.item}>
                        <div className={styles.label}>场景：</div>
                        <div className={styles.content}>{scene}</div>
                      </div>
                    }
                    <div className={styles.item}>
                      <div className={styles.label}>发送时间：</div>
                      <div className={styles.content}>{executeTime}</div>
                    </div>
                    <div className={styles.item}>
                      <div className={styles.label}>目标客户：</div>
                      <div className={styles.content}>
                        <span className={styles.totalCustomers}>{totalAmount}</span>
                        </div>
                    </div>
                    <div className={styles.item}>
                      <div style={{ color: '#606266' }}>已发送客户：</div>
                      <div className={styles.content}>
                        <span className={styles.sentCustomers}>{sendAmount ? sendAmount : 0}</span>
                        <Button
                          className={styles.checkDetailBtn}
                          onClick={() => handleCheckDetail(id)}
                        >查看详情</Button>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            />
          </div>
        </PageLayout>
      </Route>
      <Route path={`${path}/:id/:type`}>
      <DetailPage onBack={() => goBack(history, path)} />
      </Route>
    </Switch>
  );
}

export default AddFriendTasksPage;